import React from 'react';
import IconButton from '@/components/buttons/IconButton';
import { dictionaryMarkdownUrl } from '@/constants/urls';

const DictionaryMarkdownButton = ({ code, dictionaryCode, disabled }) => (
  <IconButton
    className="aridhia-dictionary-markdown-button"
    disabled={disabled}
    href={dictionaryMarkdownUrl({ code }, { code: dictionaryCode }, '#')}
    iconClassName="primary"
    iconName="file alternate outline"
    iconOnly
    messageId="actions.metadata.markdown"
  />
);

export default DictionaryMarkdownButton;
